import React from 'react';

const initialState = {
	currentUser: {} as CurrentUserDTO,
	isInitializing: true,
	tenantSettings: {} as TenantSettings,
};
const AuthContext = React.createContext(initialState);

export default AuthContext;